import React from 'react'
import Tooltip from '../Tooltip/Tooltip'
import Button from '../Button/Button'
import './TopNavBar.css'

export interface NavBarProductProps {
    url: string;
    logoTitle?: string;
    logoIcon: string;
    logoVersion: string;
    trialExpired: boolean;
    onNavigate: (url: string) => void;
    pathName?: string;
    productID?: string;
    separator?: boolean;
}

const TopNavBarProduct: React.FC<NavBarProductProps> = ({
    url,
    logoTitle,
    logoIcon,
    logoVersion,
    trialExpired,
    onNavigate,
    pathName,
    productID,
    separator
}): JSX.Element => {

    const handleRedirect = () => {
        if (url) {
            onNavigate(url);
        }
    };

    const isSelected =
        productID !== undefined &&
            pathName !== undefined &&
            productID === pathName
            ? '__isSelected'
            : '';

    return (
        <Tooltip position="right" content={logoTitle}>
            <div className='TopNavbar__content__product flex-v-center'>
                <Button
                    version='v2'
                    className={`TopNavbar__content__product__button${isSelected} flex-v-center`}
                    onClick={handleRedirect}
                    aria-label={logoTitle.toLowerCase()}
                    testId={`cs-${logoTitle.toLowerCase()}-button`}
                    role='link'
                    buttonType='tertiary'
                    icon={`v2-${logoIcon}`}
                    iconProps={{
                        version: logoVersion,
                        size: 'original',
                    }}
                    size='small'
                >
                    {logoTitle}
                </Button>
                {separator ? <div className='TopNavbar__content__product--separator'></div> : null}
            </div>
        </Tooltip>
    )
}

export default TopNavBarProduct;
